<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <zv-table :table="table" ref="dataTable">
          <div slot="ctrl-button">
            <!-- <el-button type="primary" @click="showFormDialog = true" >添加企业</el-button> -->
            <el-button type="primary" @click="$router.push('/system/addUser')">添加企业</el-button>
          </div>
        </zv-table>

        <!-- <zv-dialog
          width="600px"
          :title="isEdit ? '修改企业' : '新增企业'"
          :showDialog.sync="showFormDialog"
          @close-dialog="closeFormDialog"
        >
          <div slot="content">
            <el-form
              ref="myForm"
              label-width="140px"
              :model="formData"
              :rules="formRules"
              status-icon
            >
              <el-form-item label="企业名称：" prop="company_name">
                <el-input v-model="formData.company_name" style="width: 300px" clearable autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="企业后缀：" prop="suffix">
                <el-input v-model="formData.suffix" style="width: 300px">
                  <template slot="prepend">@</template>
                </el-input>
              </el-form-item>
              <el-form-item label="企业状态：">
                  <el-radio-group v-model="formData.type">
                    <el-radio :label="1">试用</el-radio>
                    <el-radio :label="2">正式用户</el-radio>
                    <el-radio :label="3">停用</el-radio>
                  </el-radio-group>
              </el-form-item>
              <el-form-item label="试用期：" v-if="formData.type == 1">
                  <el-date-picker
                    v-model="formData.times"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="timestamp"
                    :default-time="['00:00:00','23:59:59']"
                    @input="timeFn"
                    clearable>
                  </el-date-picker>
              </el-form-item>

              <el-form-item label="管理员账号：" prop="username">
                <el-input v-model="formData.username" clearable style="width: 300px" autocomplete="off">
                  <template slot="append">@{{formData.suffix}}</template>
                </el-input>
              </el-form-item>

              <el-form-item label="管理员密码：" prop="password">
                <el-input v-model="formData.password" type="password" style="width: 300px" autocomplete="off" clearable></el-input>
              </el-form-item> -->

              <!-- 2020.9.11 v1.5新增 -->
              <!-- <el-form-item label="公司logo:" label-width="120px">
                <div v-if="formData.logo" style="margin-bottom: 10px;">
                  <el-image
                    style="width: 60px; height: 60px"
                    :src="formData.logo"
                    fit="fill"
                    :preview-src-list="[formData.logo]"
                  >
                  </el-image>
                </div>
                <div>
                  <el-upload
                    :action="imageUrl"
                    accept="image/*"
                    :show-file-list="false"
                    :data="imageData"
                    name="file"
                    v-model="formData.logo"
                    :on-success="handleUploadSuccess"
                  >
                    <el-button size="small" type="primary">点击上传图片</el-button>
                  </el-upload>
                </div>
              </el-form-item>


              <el-form-item label="关联大屏：" v-if="isEdit">
                <div v-for="(item,index) in formData.board_list" :key="index">{{item.board_name}}</div>
              </el-form-item>

            </el-form>
          </div>
          <div slot="btns">
            <el-button @click="showFormDialog = false">取消</el-button>
            <el-button type="primary" @click="submitForm">确定</el-button>
          </div>
        </zv-dialog> -->
      </div>
    </div>
  </div>
</template>
<script>
import api from "./api";
import addFormMixin from "@/mixins/addFormMixin";
import tokenService from "@/utils/services/token_service";
export default {
  name: "businessManagement",
  mixins: [addFormMixin],
  components: {
  },
  data() {
    let vm = this;
    return {
      table: {
        api: api.businessManagement,
        query: {

        },
        searchData: [
          {
            type: "input",
            model: "id",
            placeholder: "用户ID"
          },
          {
            type: "input",
            model: "q",
            placeholder: "用户名称"
          }
        ],
        columns: [
          {
            title: "用户名称",
            key: "company_name",
            minWidth:"150",
            showTooltip: true
          },
          {
            title: "用户类型",
            minWidth:"150",
            showTooltip: true,
            render(h, ctx) {
              return h("span", ctx.row.company_type == 1 ? "政府用户" : "企业用户");
            }
          },
          {
            title: "负责人",
            key: "contact_name",
            minWidth:"150",
            showTooltip: true
          },
          {
            title: "负责人联系方式",
            key: "contact_phone",
            minWidth:"150",
            showTooltip: true
          },
          {
            title: "大屏数量",
            key: "board_count",
            minWidth:"150",
            showTooltip: true
          },
          {
            title: "创建时间",
            key: "add_time",
            minWidth:"150",
            showTooltip: true,
            render(h, ctx) {
              return h("span", vm.$commFunc.formatDate(ctx.row.add_time));
            }
          },
          {
            title: "操作人",
            key: "last_admin_username",
            minWidth: "60",
            render(h, ctx) {
              let status = ctx.row.last_admin_username;
              let statusText;
              if (status == "") {
                statusText = "--";
              } else {
                statusText = status;
              }
              return h("span", statusText);
            }
          },
          {
            title: "操作",
            fixed: "right",
            minWidth:"150",
            render(h, ctx) {
              const editBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doEdit.bind(this, ctx.row.id)
                  }
                },
                "通用设置"
              );

              const specialBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doSetting.bind(this, ctx.row.id)
                  }
                },
                "产品管理"
              );

              const delBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doDelete.bind(this, ctx.row.id)
                  }
                },
                "删除"
              );

              let arr = [];
              arr.push(editBtn);
              arr.push(specialBtn);
              arr.push(delBtn);

              return h("span", arr);
            }
          }
        ]
      },
      formDataOri: {
        company_name: '',  // 企业名字
        username: '',  // 管理员账号
        password: '',  // 管理员密码
        type: '',       // 管理员类别( 1 试用 2正式用户 3停用)
        try_start_time: '',  // 试用开始时间
        try_end_time: '', // 试用结束时间
        board_ids: '', // 关联大屏ID
      },
      formRulesOri: {
        company_name: [{
          required: true,
          message: "企业名称不能为空",
          trigger: "blur"
        }],
        suffix: [{
          required: true,
          message: "企业后缀不能为空",
          trigger: "blur"
        }],
        username: [{
          required: true,
          message: "管理员账号不能为空",
          trigger: "blur"
        }],
        realname: [{
          required: true,
          message: "真实姓名不能为空",
          trigger: "blur"
        }],
        role: {
          required: true,
          message: "请选择角色",
          trigger: "change"
        }
      },
      pwdRule: {
        password: [{
          required: true,
          message: "密码不能为空",
          trigger: "blur"
        }],
      },
      adddApi: api.addCompany,
      editApi: api.editCompany,
      deleteApi: api.deleteCompany,
      formRules: {},
      addSuccessMsg: '添加企业成功',
      editSuccessMsg: '编辑企业成功',
      deleteSuccessMsg: '删除企业成功',
      submitData: {
        company_name: '',  // 企业名字
        username: '',  // 管理员账号
        password: '',  // 管理员密码
        type: '',       // 管理员类别( 1 试用 2正式用户 3停用)
        try_start_time: '',  // 试用开始时间
        try_end_time: '', // 试用结束时间
        board_ids: '', // 关联大屏ID
      },
      roleListData: [],  // 角色数据
      rightCodeListData: [],  // 权限数据
      imageData: {
        //写死参数 后续修改
        sid: tokenService.getToken(),
        type: "1",
        dir: "logo"
      },
      imageUrl: "http://yjapi.ciwei.com/api.php?do=admin_file_upload", //写死参数
      fileList: [], //文件列表
    };
  },

  computed: {

  },

  methods: {
    doEdit(ids){
      this.$router.push({
        name: "generalSettings",
        query: {id: ids}
      })
    },

    doSetting(ids) {
      this.$router.push({
        name: "customPermissions",
        query: {id: ids}
      })
    },

    // 图片上传成功
    handleUploadSuccess(res, file) {
      this.$set(this.formData, "logo", res.file);
    },

    timeFn(e) {
      this.$nextTick(() => {
        this.formData.times = [];
        this.$set(this.formData, "times", [e[0], e[1]]);
      });
    },

    doAddExtra() {
      this.formRules = Object.assign({}, this.formRulesOri, this.pwdRule)
      console.log(this.formRules)
    },

    async doEditExtra() {
      this.formRules = Object.assign({}, this.formRulesOri)
      api.infoCompany({
        id: this.formData.id
      }).then(res => {
          this.formData = {times:[],...res.info}
          let name = this.formData.username.split("@")[0]
          // let suffix = this.formData.username.split("@")[1]
          this.formData.times.push(res.info.try_start_time * 1000)
          this.formData.times.push(res.info.try_end_time * 1000)
          this.formData.username = name
          // this.$set(this.formData,"suffix",suffix)
        })
        .catch(err => {
          this.$message(err);
        });
    },

    beforeValidate() {
      // if(this.formData.username != "") {
      //   this.formData.username = this.formData.username + "@" + this.formData.suffix
      // }
      if(this.formData.type == 1) {
        this.formData.try_start_time = this.$commFunc.parseToTimestamp(
          this.formData.times[0]
        );
        this.formData.try_end_time = this.$commFunc.parseToTimestamp(
          this.formData.times[1]
        );
      }
    },

    dealEditItem(editItem) {
      let retObj = this.$_.cloneDeep(editItem)
      retObj.role = parseInt(retObj.role)
      retObj.rightcode = retObj.rightcode ? retObj.rightcode.split(',').map(item => parseInt(item)) : []
      return retObj
    },

    // beforeSubmit() {
    //   this.submitData.rightcode = this.submitData.rightcode.join(",")
    //   // 编辑时如果求填写密码，则不传password字段
    //   if (this.isEdit && !this.formData.password) {
    //     delete this.submitData.password
    //   }
    // },
  },

  // created() {
  //   this.$api.getRoleList().then(res => {
  //     this.roleListData = res.data
  //   })

  //   this.$api.getRightCodeList().then(res => {
  //     this.rightCodeListData = res.data
  //   })
  // },

  mounted() {

  },
  beforeDestroy() {

  }
};
</script>

<style lang="less" scoped>

</style>
